import { createContext } from "react";

// Provides current mode and toggle function to entire app
const ThemeContext = createContext({
  mode:       "dark",
  toggleMode: () => {},
});

export default ThemeContext;